import classNames from 'classnames';
import { FC } from 'react';

import { CartPrice } from '@/entities/cart';
import { formatPrice } from '@/shared/lib';

import styles from './cartListTotal.module.scss';

interface CartListTotalProps {
  quantity: number;
  price: number;
  className?: string;
  discounts?: CartPrice | null;
}

const CartListTotal: FC<CartListTotalProps> = (props) => {
  const { quantity, price, discounts, className } = props;
  return (
    <div className={classNames(styles.container, className)}>
      <div className={styles.container__row}>
        <p className={styles.container__text}>Товары</p>
        <p className={styles.container__text}>{quantity}</p>
      </div>
      {!!discounts?.personal_discount && (
        <div className={styles.container__row}>
          <p className={styles.container__text}>Ваша скидка</p>
          <p className={styles.container__text}>
            -{formatPrice(discounts?.personal_discount)}
          </p>
        </div>
      )}
      {!!discounts?.promo_code?.value && (
        <div className={styles.container__row}>
          <p className={styles.container__text}>Промокод</p>
          <p className={styles.container__text}>
            -{formatPrice(discounts?.promo_code_discount ?? 0)}
          </p>
        </div>
      )}
      <hr className={styles.container__divider} />
      <div className={styles.container__row}>
        <p className={styles.container__text}>Итого</p>
        <p className={styles.container__text}>
          {formatPrice(discounts?.total_price ?? price ?? 0)}
        </p>
      </div>
    </div>
  );
};

export default CartListTotal;
